import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DtAnZipcodewidgetLibModule, DtAnVerifyZipcodeModalModule } from 'projects/dt-an-zipcodewidget-lib/src/public-api';

@NgModule({
  imports: [
    BrowserModule,
    DtAnZipcodewidgetLibModule,
    HttpClientJsonpModule,
    HttpClientModule,
    DtAnVerifyZipcodeModalModule
  ]
})
export class AppModule {
  ngDoBootstrap() { }
}
